export default __webpack_public_path__ + "static/media/zukunf_lauft_background_m2.7f09b873.jpg";